let sessionExpiredHandler = null;
let sessionExpiredNotified = false;
let sessionExpiredResetTimer = null;

export function registerSessionExpiredHandler(handler) {
  sessionExpiredHandler = handler;
}

export function isSubscriptionRequiredError(message = '') {
  const normalized = String(message).toLowerCase();
  return normalized.includes('subscription') || normalized.includes('subscribe');
}

export function isAuthSessionError(status, message = '') {
  if (isSubscriptionRequiredError(message)) return false;

  const normalized = String(message).toLowerCase();

  if (status === 401) return true;

  if (status === 403) {
    return (
      normalized.includes('token') ||
      normalized.includes('unauthorized') ||
      normalized.includes('expired') ||
      normalized.includes('revoked') ||
      normalized.includes('invalid')
    );
  }

  return (
    normalized.includes('token') &&
    (normalized.includes('expired') ||
      normalized.includes('revoked') ||
      normalized.includes('invalid') ||
      normalized.includes('unauthorized'))
  );
}

export function notifySessionExpired() {
  if (sessionExpiredNotified) return;
  sessionExpiredNotified = true;

  if (sessionExpiredResetTimer) {
    window.clearTimeout(sessionExpiredResetTimer);
  }
  sessionExpiredResetTimer = window.setTimeout(() => {
    sessionExpiredNotified = false;
    sessionExpiredResetTimer = null;
  }, 3000);

  if (typeof sessionExpiredHandler === 'function') {
    sessionExpiredHandler();
  }
}
